import { vars } from '@/app/config/variables';
import { headerMain } from './header-main/header-main.js';
import { HeaderNav } from './header-nav/header-nav';
import { HeaderSearch } from './header-search/header-search';
import { CatalogMenu } from '@/widgets/catalog-menu/catalog-menu';

export class Header {
	headerSelector = '.js-header';
	pageSelector = '.page';
	dropdownSelector = '.js-dropdown';
	contrastSurfaceSelector = '.js-header-surface';
	catalogMenuSelector = '#catalog-menu';
	headerSearchSelector = '.js-search';

	stickyClass = 'header--sticky';
	contrastClass = 'header--contrast';
	stickyOffsetVar = '--sticky-header-offset';

	constructor() {
		this.init();
	}

	init() {
		this.header = document.querySelector(this.headerSelector);
		this.page = document.querySelector(this.pageSelector);

		if (!this.header || !this.page) return;

		this.headerSearch = document.querySelector(this.headerSearchSelector);
		this.catalogMenu = document.querySelector(this.catalogMenuSelector);
		this.dropdowns = Array.from(this.header.querySelectorAll(this.dropdownSelector), (el) => app.classInstance.get(el)?.dropdown).filter(Boolean);
		this.contrastSurface = document.querySelector(this.contrastSurfaceSelector);
		this.headerHeight = this.header.offsetHeight;
		this.topOffset = 0;
		this.laptopMQ = window.matchMedia(`(width >= ${vars.breakpoint.laptop}px)`);

		this.updateTopOffset();
		this.initObserver();
		this.bindEvents();

		new HeaderNav();
		new HeaderSearch(this.headerSearch);
		new CatalogMenu(this.catalogMenu);

		headerMain();
	}

	closeDropdowns = () => {
		this.dropdowns.forEach((dropdown) => dropdown.close());
	};

	handleScroll = () => {
		const offset = window.scrollY;

		if (offset > this.topOffset) {
			this.header.classList.add(this.stickyClass);
			this.page.style.setProperty(this.stickyOffsetVar, this.headerHeight + 'px');
		} else {
			this.header.classList.remove(this.stickyClass);
			this.page.style.removeProperty(this.stickyOffsetVar);
		}

		this.closeDropdowns();
	};

	updateHeaderHeight = () => {
		this.headerHeight = this.header.offsetHeight;
	};

	updateTopOffset = () => {
		this.topOffset = this.laptopMQ.matches ? 8 : 0;
	};

	handleResize = () => {
		this.updateHeaderHeight();
		this.updateTopOffset();
		this.handleScroll();
	};

	handleIntersection = ([entry]) => {
		if (entry.isIntersecting) {
			this.header.classList.add(this.contrastClass);
		} else {
			this.header.classList.remove(this.contrastClass);
		}
	};

	initObserver() {
		if (!this.contrastSurface) return;

		this.observer = new IntersectionObserver(this.handleIntersection, {
			root: null,
			threshold: 0.05,
		});

		this.observer.observe(this.contrastSurface);
	}

	bindEvents() {
		window.addEventListener('scroll', this.handleScroll);
		this.laptopMQ.addEventListener('change', this.handleResize);
	}
}
